import { TARIFFS_REQUEST, TARIFFS_SUCCESS, TARIFFS_FAILURE } from 'app/actions/finances/tariffs';

const defaultState = {
  loading: false,
  result: null,
  tariffs: {},
};

const tariffs = (state = defaultState, action) => {
  switch (action.type) {

    case TARIFFS_REQUEST: {
      return { ...state, loading: true };
    }

    case TARIFFS_SUCCESS: {
      return { ...state, ...action.payload, loading: false };
    }

    case TARIFFS_FAILURE: {
      return { ...state, loading: false, result: null };
    }

    default:
  }
  return state;
};

export default tariffs;
